(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["salex-company-registration"]) return;
  try {
    
  function initializeSaleXCompanyForm(root) {
    const forms = root.querySelectorAll('.salex-company-registration__form');
    forms.forEach((form) => {
      if (form.dataset.companyDraftReady) return;
      form.dataset.companyDraftReady = 'true';
      const owner = form.closest('.salex-company-registration')?.dataset.companyOwner || 'guest';
      const storageKey = `salex:company-request:${owner}:${window.location.pathname}:${form.id}`;
      const result = form.querySelector('[data-company-result]');
      const fields = Array.from(form.elements).filter((field) =>
        field.name.startsWith('contact[') && field.type !== 'hidden' && !field.disabled
      );
      try {
        if (result?.dataset.companyResult === 'success') {
          window.sessionStorage.removeItem(storageKey);
        } else {
          const stored = window.sessionStorage.getItem(storageKey);
          const draft = stored ? JSON.parse(stored) : null;
          if (draft && draft.expiresAt <= Date.now()) {
            window.sessionStorage.removeItem(storageKey);
          } else if (result?.dataset.companyResult === 'error' && draft?.values) {
            fields.forEach((field) => {
              if (field.dataset.companyServerValue !== 'true' && typeof draft.values[field.name] === 'string') {
                field.value = draft.values[field.name];
              }
            });
          }
        }
      } catch {}
      if (result) result.focus();
      form.addEventListener('submit', () => {
        if (!form.checkValidity()) return;
        const values = Object.fromEntries(fields.map((field) => [field.name, field.value]));
        try {
          window.sessionStorage.setItem(storageKey, JSON.stringify({
            values,
            expiresAt: Date.now() + 30 * 60 * 1000
          }));
        } catch {}
      });
    });
  }
  initializeSaleXCompanyForm(document);
  document.addEventListener('shopify:section:load', (event) => initializeSaleXCompanyForm(event.target));

  } catch(e) { console.error(e); }
})();
})();
